import React, { Component } from "react";
import "./global.js";
//import Comments from "./Comments.js";

export default class CommentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: "",
    };

    // bind context to methods
    this.handle_message_field_changed = this.handle_message_field_changed.bind(
      this
    );
    this.onSubmit = this.onSubmit.bind(this);
  }

  /**
   * Handle form input field changes & update the state
   */

  do_my_comment_ceased_message(CommentForm_app, comments_app) {
    console.log("in do_my_comment_ceased_message.");
    clearInterval(
      CommentForm_app.state.last_time_sent_message_changed_timeout_function
    );
    //
    var op = "client_message_entered_ceased";
    var entered_message = comments_app.state.my_comment_message;
    comments_app.ws.send(
      JSON.stringify({
        op: op,
        entered_message: entered_message,
        room_title: global.title,
      })
    );
    console.log("ws.send op: " + op + " entered_message: " + entered_message + " room_title: " + global.title);
  }

  handle_message_field_changed = (event) => {
    console.log("in handle_message_field_changed.");
    const { value, name } = event.target;
    this.props.primary_app.setState({
      my_comment_message: value,
    });
    if (name === "message") {
      var state = this.props.primary_app.state;
      if (!this.props.primary_app.props.main_app.state.report_typing) {
        return;
      }
      var current_time = new Date().getTime();
      clearInterval(
        this.props.primary_app.state
          .last_time_sent_message_changed_timeout_function
      );
      if (
        state.last_time_sent_message_changed === undefined ||
        state.last_time_sent_message_changed < current_time - 2000
      ) {
        this.props.primary_app.setState({
          last_time_sent_message_changed: current_time,
        });
        var op = "client_message_entered_changed";
        var entered_message = value;
        this.props.primary_app.ws.send(
          JSON.stringify({
            op: op,
            entered_message: entered_message,
            room_title: global.title,
          })
        );
        console.log(
          "ws.send op: " + op + " entered_message: " + entered_message + " room_title: " + global.title
        );
        //
      }
      //
      this.props.primary_app.state.last_time_sent_message_changed_timeout_function = setTimeout(
        function (form_app) {
          if (!form_app.props.primary_app.props.main_app.state.report_typing) {
            return;
          }
          console.log("in last_time_sent_message_changed_timeout_function !!!");
          form_app.do_my_comment_ceased_message(
            form_app,
            form_app.props.primary_app
          );
        },
        value != "" ? 4000 : 1000,
        this
      );
      // this.do_my_comment_ceased_message(this, this.props.comments_app);
      // //
    } else {
      throw "unrecognized name: " + name;
    }
  };

  /**
   * Form submit handler
   */
  onSubmit(e) {
    console.log("in onSubmit.");
    // prevent default form submission
    e.preventDefault();

    if (!this.isFormValid()) {
      this.setState({ error: "All fields are required." });
      return;
    }

    // loading status and clear error
    this.setState({ error: "", loading: true });

    // persist the comments on server
    let my_comment = {
      name: this.props.primary_app.props.main_app.state.my_name,
      message: this.props.primary_app.state.my_comment_message,
      ref: undefined,
    };
    
    // Ensure title is included - construct from window.location.search if title_arg is missing
    let title_param = window.location.title_arg;
    if (!title_param && window.location.search) {
      // Extract title from query string directly
      const searchParams = new URLSearchParams(window.location.search);
      const title = searchParams.get('title');
      if (title) {
        title_param = `title=${encodeURIComponent(title)}&`;
      }
    }
    // Fallback to global.title if still no title
    if (!title_param && global.title && global.title !== "Root") {
      title_param = `title=${encodeURIComponent(global.title)}&`;
    }
    
    const url = global.server_url +
      "?" +
      (title_param || '') +
      "op=comment_added" +
      "&browser_id=" +
      this.props.browser_id;
    
    console.log("Submitting comment to URL:", url);
    console.log("Comment data:", my_comment);
    console.log("window.location.search:", window.location.search);
    console.log("window.location.title_arg:", window.location.title_arg);
    console.log("global.title:", global.title);
    console.log("title_param:", title_param);
    
    fetch(url, {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(my_comment),
    })
      .then(async (res) => {
        console.log("Response status:", res.status);
        console.log("Response headers:", res.headers);
        const text = await res.text();
        console.log("Response body:", text);
        
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}, body: ${text}`);
        }
        
        try {
          return JSON.parse(text);
        } catch (e) {
          throw new Error(`Failed to parse JSON response: ${text}`);
        }
      })
      .then((res) => {
        console.log("Parsed response:", res);
        if (res.error) {
          this.setState({ loading: false, error: res.error });
        } else {
          // add time return from api and push comment to parent state
          my_comment._id = res._id;
          my_comment.time = res.time;
          my_comment.user_ip = res.user_ip;
          this.props.addComment(my_comment);
          //
          this.setState({ loading: false });
          // clear the message box
          this.props.primary_app.setState({
            my_comment_message: "",
          });
          this.do_my_comment_ceased_message(this, this.props.primary_app);
          //
          if (my_comment.ref && my_comment.ref.current) {
            my_comment.ref.current.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
          }
        }
      })
      .catch((err) => {
        console.error("Error submitting comment:", err);
        console.error("Error stack:", err.stack);
        this.setState({
          error: "Something went wrong while submitting form: " + err.message,
          loading: false,
        });
      });
  }

  /**
   * Simple validation
   */
  isFormValid() {
    return (
      this.props.primary_app.props.main_app.state.my_name !== "" &&
      this.props.primary_app.state.my_comment_message !== ""
    );
  }

  renderError() {
    return this.state.error ? (
      <div className="alert alert-danger">{this.state.error}</div>
    ) : null;
  }

  render() {
    var is_connected = this.props.primary_app.state.status_txt != "Connected";
    return (
      <React.Fragment>
        {/* <h5 className="text-muted mb-3">
          chars{" "}
          {this.state.comment.name.length + this.state.comment.message.length}
        </h5> */}
        <form method="post" onSubmit={this.onSubmit}>
          <div className="d-flex flex-row">
            <input
              className=""
              value={this.props.primary_app.state.my_comment_message}
              onChange={this.handle_message_field_changed}
              style={{
                margin: 0,
                borderRadius: "0.3rem",
                width: "100%",
                paddingLeft: "6px",
              }}
              placeholder="♥️ Your Comment"
              name="message"
              disabled={is_connected}
            />
            <button
              style={{ marginLeft: "8px", padding: "0 5px 0 6px" }}
              className="btn btn-primary"
              disabled={this.state.loading || is_connected}
            >
              &#10148;
            </button>
          </div>
          {this.renderError()}
        </form>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CommentForm.js